import PropTypes from "prop-types";
import {Animated, Dimensions, Easing, Image, PanResponder, Pressable, ScrollView, StyleSheet, View} from "react-native";
import React, {useContext, useEffect, useRef, useState} from "react";
import MainHeader from "../assets/MainHeader";
import Text from "./Text";
import {Colors} from "../colors";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {MenuDetails} from "../../../rest/jtmc/models/MenuDetails";
import TableNumberBackground from "../assets/TableNumberBackground";
import CategoryIndicator from "../assets/CategoryIndicator";
import {navigate} from "../../../refrences/RootNavigation";
import ThemeContext from "@react-navigation/native/lib/typescript/src/theming/ThemeContext";
import Category from "../../../rest/jtmc/models/Category";
import {ProductAndItsCategory} from "../../../rest/jtmc/models/ProductAndItsCategory";

// Should be more than 1
const size = 6.4;
const itemWidth = 52;
const itemMargin = 1.4;



export const headerHeight = 70;
export function HeaderComponents(props: { menuDetails: MenuDetails }) {
    const blinkingAnimation = useRef(new Animated.Value(1)).current;
    const colors = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    const TableNumberView = () => {
        return useContext(AppConfigContext).orderType == "table" ?
            <View style={{height: 25, width: 115, paddingBottom: 2, justifyContent: "center", alignItems: "center"}}>
                <TableNumberBackground/>
                <View style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <Text size={10} color={"white"}
                          weight={600}>{`شماره میز شما: ${props.menuDetails.tableNumber}`}</Text>
                </View>
            </View> : <></>;
    }

    return <View style={{justifyContent: "center", alignItems: "center", height: 71}}>
        <View style={{flexDirection: "row", flexGrow: 1, padding: 6, flex: 1, width: "100%", maxWidth: 570}}>

            <Pressable onPress={() => navigate("BranchInfoScreen", {
                branchInfo: props.menuDetails?.branchInfo
            })} style={{flexGrow: 1, flexBasis: 1, justifyContent: "center", alignItems: "center"}}>
                <Text color={"#fff"} size={13} weight={700}>{props.menuDetails.branchInfo.storeName}</Text>
                <Text color={"#fff"} size={10} weight={600}>(مشاهده اطلاعات مجموعه)</Text>
            </Pressable>
            <Pressable onPress={() => navigate("BranchInfoScreen", {
                    branchInfo: props.menuDetails?.branchInfo
                })}>
                <Image resizeMode={"contain"} style={{width: 80, height: "100%"}}
                       source={{uri: props.menuDetails.branchInfo.logoUrl}}/>
            </Pressable>
            <Pressable onPress={()=>{
                navigate("BranchWorkingTime", {
                    branchInfo: props.menuDetails?.branchInfo
                });
            }} style={{flexGrow: 1, flexBasis: 1, justifyContent: "center", alignItems: "center"}}>
                {props.menuDetails.branchInfo.isInActiveTime ?

                    <Animated.View style={{justifyContent: "center", alignItems: "center", opacity: blinkingAnimation}}>

                        <Text style={{
                            paddingHorizontal: 8, paddingVertical: 2, backgroundColor: colors.get("green") as string,
                            borderRadius: 8
                        }} color={"#fff"} size={11} weight={700}>آماده پذیرش سفارش</Text>

                    </Animated.View>

                     :
                    <View style={{justifyContent: "center", alignItems: "center"}}>
                        <Animated.View style={{justifyContent: "center", alignItems: "center", opacity: blinkingAnimation}}>
                            <Text style={{
                                paddingHorizontal: 8, paddingVertical: 2, backgroundColor: "#f00",
                                borderRadius: 8
                            }} color={"#fff"} size={12} weight={700}>تعطیل</Text>
                        </Animated.View>
                        <Text color={"#fff"} size={10} weight={600}>(مشاهده ساعت فعالیت)</Text>
                    </View>
                }
            </Pressable>
        </View>
        <TableNumberView/>
    </View>;
}

function SimpleSpinner(props: {
    menuDetails: MenuDetails | undefined,
    selectedCategoryId: number,
    onItemChange: (item: Category, index: number) => void
}) {
    const [initiationSelectFired, setInitiationSelectFired] = useState(false);
    const menuDetails: MenuDetails | undefined = props.menuDetails;
    //
    // const audio = new Audio(spinnerSoundEffect);
    // audio.play();
    const colors = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    const styles = lStyles(colors);

    useEffect(() => {
        if(menuDetails!=null && !initiationSelectFired) {
            const category = menuDetails.menuItems[0]?.category ?? null;
            if(category == null)
                return;

            props.onItemChange(category, 0);
        }
    }, [menuDetails,initiationSelectFired]);
    return menuDetails != null ? <View style={{display: "flex", flexDirection: "column"}}>

        <Pressable style={{height: headerHeight, width: "100%", position: "absolute"}}>
            <MainHeader height={headerHeight}/>
        </Pressable>

        <HeaderComponents menuDetails={menuDetails}/>
        {/*<CategoryIndicator/>*/}

        <ScrollView horizontal
                    contentContainerStyle={{gap: 10}}
                    style={styles.scrollContainer}
                    snapToInterval={200}
                    decelerationRate={0}
                    snapToAlignment={"center"}>

            {menuDetails.menuItems.map((item, index) =>
                <SpinnerItem data={item} selected={props.selectedCategoryId == item.category.id}
                             index={index} onPress={(index)=>{
                    props.onItemChange(item.category, index)
                }}/>
            )}

        </ScrollView>

    </View>: <></>
}

const SpinnerItem = React.memo((props: {
    data: ProductAndItsCategory,
    selected: boolean,
    onPress: (index: number) => void,
    index: number
}) => {
    const styles = lStyles(Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color));
    return <Pressable onPress={() => props.onPress(props.index)}
                      style={[styles.itemContainer]}>
        <View style={[styles.imageContainer, props.selected ? styles.selectedImageContainer : {}]}>
            <Image style={styles.image} source={{uri: props.data.category.logo}}/>
        </View>
        <Text numberOfLines={2} size={11} style={styles.text}>{props.data.category.name}</Text>
    </Pressable>
});

const lStyles = (colors: Colors) => StyleSheet.create({
    handlerCircle: {
        position: "absolute"
    },
    scrollContainer: {
        backgroundColor: colors.get("transparentBackgroundHighlight") as string,
        paddingHorizontal: 20,
        paddingVertical: 10,
        paddingTop: 60,
        marginTop: -50,
        zIndex: -10
    },
    itemContainer: {
        alignItems: "center",
    },
    imageContainer: {
        width: itemWidth,
        height: itemWidth,
        borderColor: colors.get("separator") as string, borderWidth: 1.5, borderRadius: 50,
        justifyContent: "center",
        alignItems: "center"
    },
    selectedImageContainer: {
        borderWidth: 0,
        backgroundColor: colors.get("primaryColor") as string
    },
    image: {
        width: 29,
        height: 29
    },
    text: {
        textAlign: "center", width: 60, marginTop: 4
    }
});


export default SimpleSpinner;